import { render } from "./DiscountForm.vue?vue&type=template&id=366a124a"
import script from "./DiscountForm.vue?vue&type=script&lang=js"
export * from "./DiscountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__